import { render, staticRenderFns } from "./ProblemControler.vue?vue&type=template&id=2d32c6a3&scoped=true&"
import script from "./ProblemControler.vue?vue&type=script&lang=js&"
export * from "./ProblemControler.vue?vue&type=script&lang=js&"
import style0 from "./ProblemControler.vue?vue&type=style&index=0&id=2d32c6a3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d32c6a3",
  null
  
)

export default component.exports